import React from "react";

export const MiniCardComponent = (props) => {
    return (
        <div className="ibox no-margins">
            <div className="ibox-content">
                <h1 className="no-margins">{props.value}</h1>
                <small className='font-weight-bold'>{props.text}</small>
            </div>
        </div>
    )
}
